import { importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BaseDataService } from 's1m-angular-common-lib';
import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

import { apiUrlInterceptor } from './interceptors/api.url.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { blobErrorInterceptor } from './interceptors/blob-error.interceptor';
import { httpErrorInterceptor } from './interceptors/http-error.interceptor';
import { refreshTokenInterceptor } from './interceptors/refresh-token.interceptor';
import { APP_ROUTES } from './app.routes';
import { NgSelectModule } from '@ng-select/ng-select';
import { DndModule } from 'ngx-drag-drop';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserModule } from '@angular/platform-browser';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MatCheckboxModule } from '@angular/material/checkbox';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const appDatepickerConfig: Partial<BsDatepickerConfig> = {
  containerClass: 'app-theme',
  dateInputFormat: 'DD.MM.YYYY',
  showWeekNumbers: false,
  customTodayClass: 'today-class',
  adaptivePosition: true,
};

const appDaterangepickerConfigBase: Partial<BsDaterangepickerConfig> = {
  ...appDatepickerConfig,
  rangeInputFormat: 'DD.MM.YYYY',
};

export const appConfig = {
  providers: [
    provideAnimations(),
    provideRouter(APP_ROUTES, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([
        apiUrlInterceptor,
        refreshTokenInterceptor,
        authInterceptor,
        httpErrorInterceptor,
        blobErrorInterceptor,
      ]),
    ),
    importProvidersFrom(
      BrowserModule,
      FontAwesomeModule,
      NgSelectModule,
      DndModule,
      ModalModule.forRoot(),
      PopoverModule.forRoot(),
      InfiniteScrollModule,
      BsDropdownModule.forRoot(),
      TabsModule.forRoot(),
      TooltipModule.forRoot(),
      BrowserAnimationsModule,
      HttpClientModule,
      MatCheckboxModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    { provide: BsDatepickerConfig, useFactory: () => Object.assign(new BsDatepickerConfig(), appDatepickerConfig) },
    {
      provide: BsDaterangepickerConfig,
      useFactory: () => Object.assign(new BsDaterangepickerConfig(), appDaterangepickerConfigBase),
    },
    BaseDataService,
  ],
};
